<script setup>
import { PenBoxIcon } from 'lucide-vue-next'
import { SecondaryButton } from '@codinglabsau/ui'
import ProfileLayout from '@/Layouts/ProfileLayout.vue'

defineProps({
  user: Object,
  claims: Object,
  achievementsCount: Number,
  unlockedAchievementsCount: Number,
  achievements: Object,
})
</script>

<template>
  <ProfileLayout
    :user="user"
    :claims="claims"
    :achievements-count="achievementsCount"
    :unlocked-achievements-count="unlockedAchievementsCount"
    :achievements="achievements"
  >
    <template #user-actions>
      <SecondaryButton class="w-full justify-center" rel="nofollow" :href="route('account.edit')">
        <PenBoxIcon class="mr-2 size-5" />
        Edit
      </SecondaryButton>
    </template>
  </ProfileLayout>
</template>
